export default __webpack_public_path__ + "static/media/panadero.7f4f7cf0.png";